import React from 'react'
import { useLocation } from '@reach/router'
import { parseSearchParams } from '../../utils'

function CustomDiseaseSearchCondition() {
  const [conditionText, setConditionText] = React.useState('')
  const { search } = useLocation()
  const [params, setParams] = React.useState(() => parseSearchParams(search))

  React.useEffect(() => setParams(parseSearchParams(search)), [search])

  React.useEffect(() => {
    if (params.q) {
      setConditionText(`「${params.q}」を含む`)
    } else if (params.h) {
      setConditionText(`「${params.h}」で始まる`)
    } else if (params.p) {
      setConditionText(`「${params.p}」に関する`)
    }
  }, [params])

  return <>{conditionText}</>
}

export { CustomDiseaseSearchCondition }
